export const theme = {
  colors: {
    pageBg: "rgba(18, 24, 40, 0.95)",
    sectionBg: "rgba(22, 28, 50, 0.85)",
    sectionBgAlt: "rgba(22, 28, 50, 0.88)",
    cardBg: "rgba(22, 28, 50, 0.88)",
    altCardBg: "rgba(20, 35, 60, 0.88)",
    cardHoverBg: "rgba(255, 111, 32, 0.15)",
    cardHoverBgAlt: "rgba(255, 111, 32, 0.1)",
    textColor: "#F4F4F6",
    textSecondary: "#A0AEC0",
    accentColor: "#FF6F20",
    accentCyan: "#00FFD0",
    headingColor: "#FF6F20",
    statLabelColor: "#F4F4F6",
    statNumberColor: "#FF9B40",
    cardBorderColor: "rgba(255, 111, 32, 0.6)",
    
    homeMainBg: "#111827",
    homeCardBg: "rgba(22, 24, 40, 0.70)",
    
    contactPageBg: "#0f172a",
    contactInputBg: "#1e293b",
    contactTextColor: "#e2e8f0",
    contactAccentColor: "#f97316",
    errorColor: "#f87171",
    
    altInputBg: "rgba(28, 38, 58, 0.94)",
    
    tableBg: "rgba(22, 28, 50, 0.88)",
    rowHoverBg: "rgba(255, 111, 32, 0.1)",
    tdColor: "rgba(255, 255, 255, 0.8)",
    theadBg: "rgba(0, 114, 184, 0.2)",
    thColor: "#63b3ed",
    primaryBtnColor: "#FF6F20",
    
    portfolioDescColor: "rgba(255, 255, 255, 0.7)",
    portfolioOverlayBg: "rgba(20, 43, 71, 0.9)",
    portfolioOverlayTextColor: "#FF6F20",
    borderColor: "rgba(255, 111, 32, 0.5)",
    productDescColor: "rgba(255, 255, 255, 0.7)",
  },
  borders: {
    homeCardBorder: "1.5px solid rgba(0, 255, 208, 0.24)",
  },
  effects: {
    cardBlur: "blur(10px)",
  },
  portfolio: {
    cardThemes: [
      { bg: "rgba(0,114,184,0.1)", border: "#0072B8", icon: "#0072B8" },
      { bg: "rgba(255,111,32,0.1)", border: "#FF6F20", icon: "#FF6F20" },
      { bg: "rgba(0,114,184,0.15)", border: "#0072B8", icon: "#0072B8" },
      { bg: "rgba(255,111,32,0.2)", border: "#FF6F20", icon: "#FF6F20" },
      { bg: "rgba(0,114,184,0.12)", border: "#0072B8", icon: "#0072B8" },
      { bg: "rgba(255,111,32,0.12)", border: "#FF6F20", icon: "#FF6F20" },
      { bg: "rgba(0,114,184,0.15)", border: "#0072B8", icon: "#0072B8" },
      { bg: "rgba(128,90,213,0.12)", border: "#805AD5", icon: "#805AD5" },
    ]
  },
  technologies: {
    sectionBgs: [
      "rgba(0, 114, 184, 0.12)",
      "rgba(255, 111, 32, 0.12)",
      "rgba(100, 112, 230, 0.12)",
    ],
    sectionBorders: [
      "rgba(0, 114, 184, 0.7)",
      "rgba(255, 111, 32, 0.7)",
      "rgba(100, 112, 230, 0.7)",
    ],
  }
};